import { NgModule } from "@angular/core";

import { NativeNotificationService } from "./NativeNotificationService";

@NgModule({
  providers: [NativeNotificationService],
})
export class NativeDesktopServicesModule {}
